var e={"Personal information":"個人情報",Signature:"個性署名",Gender:"性別",Male:"男",Female:"女",AllowType:"友達追加の認証方法",NeedConfirm:"認証が必要",AllowAny:"どのユーザーにも友達追加を許可",DenyAny:"どのユーザーにも友達追加を拒否",Birthday:"誕生日",Unknown:"未設定"};export{e as default};
